import { identity } from 'fp-ts/lib/function';
import type { Draft } from 'immer';

/**
 * Producer typing has sometimes problem to determine that T is assignable to Draft<T>.
 *
 * This helper allows bypassing that problem, but use with caution, obviously it does
 * not make the passed object an actual writable draft.
 *
 * @example
 * const fn = <TRow extends unknown>(state: {rows: TRow[]}, newRows: TRow) => {
 *   produce(state, draft => {
 *     // type error
 *     draft.rows = newRows;
 *     // OK
 *     draft.rows = unsafeAsDraft(newRows);
 *   });
 * }
 */
export const unsafeAsDraft: <T>(value: T) => Draft<T> = identity as any;
